import { useAtomValue } from 'jotai';
import { domain } from 'modules/data';
import { netSuiteBillFieldValuesState } from 'shared/states';

export const useGetContactIdForOcrSuggests = (request: domain.Request | null) => {
    const netSuiteBillFieldValues = useAtomValue(netSuiteBillFieldValuesState);

    switch (request?.integrationCode) {
        case domain.IntegrationCode.XeroBill:
        case domain.IntegrationCode.XeroPo:
        case domain.IntegrationCode.XeroInvoice:
        case domain.IntegrationCode.XeroCreditNotesPayable:
            return request?.details.contact?.id;
        case domain.IntegrationCode.QBooksBill:
            return request?.details.vendor?.id;
        case domain.IntegrationCode.QBooksExpense: {
            return request?.details.payee?.id;
        }

        case domain.IntegrationCode.NetSuiteBill:
            return netSuiteBillFieldValues.vendor?.id;
        default:
            return undefined;
    }
};
